import { State } from "../types/store";

export const selectFormSettings = (state: State) => state.settings;
export const selectFormGeneralSettings = (state: State) => state.settings.general;
export const selectFormLimitSettings = (state: State) => state.settings.limits;
export const selectFormNotificationsSettings = (state: State) => state.settings.notification;
export const selectFormSaveProgressSettings = (state: State) => state.settings.saveProgress;
export const selectFormConfirmationSettings = (state: State) => state.settings.confirmation;

export const selectFormNativeSettings = (state: State) => state.settings.native;
